import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgOk(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.2476 14.1191C19.1303 15.2364 17.5916 15.9325 15.8881 15.9325C14.1846 15.9325 12.6459 15.2364 11.5285 14.1191C10.4111 13.0017 9.71505 11.4632 9.71505 9.75963C9.71505 8.05608 10.4111 6.51736 11.5285 5.39995C12.6459 4.28254 14.1846 3.58667 15.8881 3.58667C17.5916 3.58667 19.1303 4.28254 20.2476 5.39995C21.3649 6.51736 22.061 8.05608 22.061 9.75963C22.061 11.4632 21.3649 13.0017 20.2476 14.1191ZM15.8881 6.93867C15.1187 6.93867 14.4226 7.25003 13.9098 7.76301C13.3969 8.27577 13.0854 8.97186 13.0854 9.74111C13.0854 10.5106 13.3969 11.2067 13.9098 11.7196C14.4226 12.2324 15.1187 12.5438 15.8881 12.5438C16.6574 12.5438 17.3535 12.2324 17.8663 11.7196C18.3792 11.2067 18.6906 10.5106 18.6906 9.74111C18.6906 8.97186 18.3792 8.27577 17.8663 7.76301C17.3535 7.26832 16.6574 6.93867 15.8881 6.93867ZM22.3723 15.9508L24.1858 18.4237C24.2775 18.5519 24.2592 18.7167 24.131 18.8083C22.6105 20.054 20.8338 20.8782 18.9837 21.3179L22.4823 28.0586C22.574 28.2602 22.4457 28.48 22.226 28.48H18.4891C18.3792 28.48 18.2693 28.4067 18.2143 28.2968L15.8881 22.7282L13.5434 28.2784C13.5068 28.3883 13.3969 28.4616 13.2686 28.4616H9.53185C9.31202 28.4616 9.1838 28.2236 9.27549 28.0404L12.7741 21.3179C10.924 20.8782 9.16554 20.054 7.62683 18.8083C7.51697 18.7167 7.48034 18.5335 7.57195 18.4237L9.38536 15.9508C9.49523 15.8043 9.67843 15.7859 9.80665 15.8959C11.5102 17.3429 13.6167 18.2955 15.8697 18.2955C18.1227 18.2955 20.2109 17.3613 21.9327 15.8959C22.0793 15.7859 22.2809 15.8043 22.3723 15.9508Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgOk);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
